// import React, { useEffect, useState } from "react";
// import { createPortal } from "react-dom";
// import { 
//   Building2, 
//   Users, 
//   UserCheck,
//   Clock, 
//   Search, 
//   Award, 
//   CalendarDays, 
//   Coffee,
//   X,
//   ChevronRight,
//   Mail,
//   AlertOctagon,
//   CheckCircle2,
//   Filter,
//   Send
// } from "lucide-react";
// import AttendanceLoader from "./AttendanceLoader";
// import "../styles/AttendanceRuleInfractions.css";

// function AttendanceRuleInfractions() {
//   const [data, setData] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [selectedDept, setSelectedDept] = useState("ALL");
//   const [activeFilter, setActiveFilter] = useState("ALL"); // ALL, BREAK, LATE
//   const [search, setSearch] = useState("");
//   const [detailModalEmp, setDetailModalEmp] = useState(null);
//   const [isHrEmailModalOpen, setIsHrEmailModalOpen] = useState(false);
//   const [emailSending, setEmailSending] = useState(false);
//   const [emailStatus, setEmailStatus] = useState(null);
//   const [showSuccessPopup, setShowSuccessPopup] = useState(false);

//   const targetEmail = "nisha.kenchgali@genesistech.co.in";

//   const parseJsonSafe = (text) => {
//     const jsonStart = text.search(/[\{\[]/);
//     if (jsonStart !== -1) {
//       return JSON.parse(text.substring(jsonStart));
//     }
//     return JSON.parse(text);
//   };

//   useEffect(() => {
//     fetch("/gt-api/get_department_analytics.php")
//       .then((res) => res.text())
//       .then((text) => {
//         const result = parseJsonSafe(text);
//         setData(result);
//         setLoading(false);
//       })
//       .catch((err) => {
//         console.error("Rule Infractions Fetch Error:", err);
//         setLoading(false);
//       });
//   }, []);

//   // Lock background scroll when any modal is open
//   useEffect(() => {
//     if (detailModalEmp || isHrEmailModalOpen || showSuccessPopup) {
//       document.body.style.overflow = "hidden";
//     } else {
//       document.body.style.overflow = "";
//     }
//     return () => {
//       document.body.style.overflow = "";
//     };
//   }, [detailModalEmp, isHrEmailModalOpen, showSuccessPopup]);

//   const handleSendEmailToHR = async () => {
//     setEmailSending(true);
//     setEmailStatus(null);
//     try {
//       const res = await fetch("/gt-api/send_rule_violations_email.php");
//       const text = await res.text();
//       const result = parseJsonSafe(text);

//       if (result.status === "success") {
//         setEmailStatus("success");
//         setShowSuccessPopup(true);
//       } else {
//         alert("❌ Email Sending Error: " + (result.message || "Failed to send email"));
//         setEmailStatus("error");
//       }
//       setEmailSending(false);
//     } catch (err) {
//       console.error("Email Sending Error:", err);
//       alert("❌ Failed to connect to email server");
//       setEmailStatus("error");
//       setEmailSending(false);
//     }
//   };

//   if (loading) {
//     return (
//       <AttendanceLoader 
//         message="Calculating Rule Infractions & Analytics..." 
//         subtitle="Please wait a moment while break durations and late arrival metrics are processed." 
//       />
//     );
//   }

//   if (!data || !data.department_summaries) {
//     return <div className="infraction-empty">No rule infraction data available.</div>;
//   }

//   const allDepts = data.all_departments || [];
//   const deptSummaries = data.department_summaries || [];
//   const allEmployees = data.employee_records || [];

//   // Filter ONLY rule violators (employees with break violations OR penalty late marks)
//   const ruleViolatorsList = allEmployees.filter((emp) => emp.has_break_violation || emp.has_late);

//   // Department-filtered rule violators
//   const deptFilteredViolators = ruleViolatorsList.filter((emp) => 
//     selectedDept === "ALL" || emp.department === selectedDept
//   );

//   // Dynamic Summary Metrics per department
//   let activeSummary = {
//     total_violators: deptFilteredViolators.length,
//     break_violators: deptFilteredViolators.filter((e) => e.has_break_violation).length,
//     late_violators: deptFilteredViolators.filter((e) => e.has_late).length,
//     total_break_days: 0,
//     total_late_marks: 0
//   };

//   deptFilteredViolators.forEach((e) => {
//     activeSummary.total_break_days += e.break_violations;
//     activeSummary.total_late_marks += e.late;
//   });

//   const handleCardFilterClick = (filterType) => {
//     if (activeFilter === filterType) {
//       setActiveFilter("ALL");
//     } else {
//       setActiveFilter(filterType);
//     }
//   };

//   // Filtered table rows
//   const filteredViolators = deptFilteredViolators.filter((emp) => {
//     const matchesSearch = 
//       emp.name.toLowerCase().includes(search.toLowerCase()) ||
//       emp.emp_code.toLowerCase().includes(search.toLowerCase()) ||
//       emp.department.toLowerCase().includes(search.toLowerCase());

//     let matchesFilter = true;
//     if (activeFilter === "BREAK") matchesFilter = emp.has_break_violation;
//     if (activeFilter === "LATE") matchesFilter = emp.has_late;

//     return matchesSearch && matchesFilter;
//   });

//   return (
//     <div className="infraction-container">
//       {/* 🔷 SCREEN HEADER */}
//       <div className="infraction-header">
//         <div>
//           <h2>⚠️ Rule Broken Employees Report</h2>
//           <p className="infraction-subtitle">
//             <CalendarDays size={14} style={{ display: "inline", marginRight: "4px" }} />
//             Report Month: <strong>{data.report_month || "Current Month"}</strong>
//           </p>
//         </div>

//         <div className="dept-filter-controls">
//           <Building2 size={18} className="dept-icon" />
//           <select 
//             className="dept-select"
//             value={selectedDept}
//             onChange={(e) => {
//               setSelectedDept(e.target.value);
//               setActiveFilter("ALL");
//             }}
//           >
//             <option value="ALL">All Departments ({deptSummaries.length} Teams)</option>
//             {allDepts.map((dept, i) => (
//               <option key={i} value={dept}>
//                 {dept}
//               </option>
//             ))}
//           </select>
//         </div>
//       </div>

//       {/* 🔷 SUCCESS NOTIFICATION TOAST ON MAIN SCREEN */}
//       {emailStatus === "success" && (
//         <div className="email-toast success-toast">
//           <CheckCircle2 size={18} />
//           <span>Rule Infractions Report successfully sent to <strong>{targetEmail}</strong> via PHPMailer SMTP! 📧</span>
//           <button onClick={() => setEmailStatus(null)} className="toast-close"><X size={14} /></button>
//         </div>
//       )}

//       {/* 🔷 4 SYMMETRICAL PREMIUM SUMMARY CARDS */}
//       <div className="infraction-metrics-grid">
//         <div 
//           className={`infraction-card card-purple ${activeFilter === 'ALL' ? 'active-card' : ''}`}
//           onClick={() => setActiveFilter('ALL')}
//           style={{ cursor: "pointer" }}
//           title={`Click to view all ${activeSummary.total_violators} rule broken employees in ${selectedDept === 'ALL' ? 'all departments' : selectedDept}`}
//         >
//           <div className="card-icon-wrapper icon-purple">
//             <AlertOctagon size={22} color="#8b5cf6" />
//           </div>
//           <div className="card-info">
//             <p>Rule Broken Employees</p>
//             <strong>{activeSummary.total_violators} <span className="sub-label">People Total</span></strong>
//           </div>
//         </div>

//         <div 
//           className={`infraction-card card-red ${activeFilter === 'BREAK' ? 'active-card' : ''}`}
//           onClick={() => handleCardFilterClick('BREAK')}
//           style={{ cursor: "pointer" }}
//           title={`Click to filter break exceeded employees in ${selectedDept === 'ALL' ? 'all departments' : selectedDept}`}
//         >
//           <div className="card-icon-wrapper icon-red">
//             <Coffee size={22} color="#ef4444" />
//           </div>
//           <div className="card-info">
//             <p>Break Exceeded</p>
//             <strong>{activeSummary.break_violators} <span className="sub-label">People</span></strong>
//           </div>
//         </div>

//         <div 
//           className={`infraction-card card-amber ${activeFilter === 'LATE' ? 'active-card' : ''}`}
//           onClick={() => handleCardFilterClick('LATE')}
//           style={{ cursor: "pointer" }}
//           title={`Click to filter late mark employees in ${selectedDept === 'ALL' ? 'all departments' : selectedDept}`}
//         >
//           <div className="card-icon-wrapper icon-amber">
//             <Clock size={22} color="#f59e0b" />
//           </div>
//           <div className="card-info">
//             <p>Late Marks</p>
//             <strong>{activeSummary.late_violators} <span className="sub-label">People</span></strong>
//           </div>
//         </div>

//         {/* 🔷 CLICKABLE TARGET HR RECIPIENT CARD */}
//         <div 
//           className="infraction-card card-blue clickable-hr-card" 
//           onClick={() => setIsHrEmailModalOpen(true)}
//           title={`Click to open email modal and send report to ${targetEmail}`}
//         >
//           <div className="card-icon-wrapper icon-indigo">
//             <Mail size={22} color="#4f46e5" />
//           </div>
//           <div className="card-info">
//             <p>Target HR Recipient</p>
//             <strong className="hr-email-text" title={targetEmail}>{targetEmail}</strong>
//             <span className="send-hr-badge">Click to Send Email 📧</span>
//           </div>
//         </div>
//       </div>

//       {/* 🔷 RULE BROKEN EMPLOYEES TABLE */}
//       <div className="infraction-table-section">
//         <div className="infraction-table-header">
//           <div>
//             <h3 style={{ margin: 0 }}>
//               Rule Infraction Employees List 
//               <span className="count-badge">({filteredViolators.length} Employees)</span>
//               {selectedDept !== "ALL" && (
//                 <span style={{ fontSize: "13px", color: "#4338ca", marginLeft: "8px", fontWeight: "normal" }}>
//                   [{selectedDept} Team]
//                 </span>
//               )}
//             </h3>
//             {activeFilter !== "ALL" && (
//               <p style={{ margin: "4px 0 0 0", fontSize: "12px", color: "#4f46e5", fontWeight: "600" }}>
//                 <Filter size={12} style={{ display: "inline", marginRight: "4px" }} />
//                 Filtered by: {
//                   activeFilter === 'BREAK' ? 'Break Exceeded People' : 'Late Marks People'
//                 }
//               </p>
//             )}
//           </div>

//           <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
//             {(activeFilter !== "ALL" || selectedDept !== "ALL") && (
//               <button className="reset-filter-btn" onClick={() => { setActiveFilter("ALL"); setSelectedDept("ALL"); }}>
//                 Reset All Filters
//               </button>
//             )}
//             <div className="infraction-search-box">
//               <Search size={16} className="search-icon" />
//               <input
//                 type="text"
//                 placeholder="Search employee or department..."
//                 value={search}
//                 onChange={(e) => setSearch(e.target.value)}
//               />
//             </div>
//           </div>
//         </div>

//         <table className="infraction-table">
//           <thead>
//             <tr>
//               <th>Emp Code</th>
//               <th>Employee Name</th>
//               <th>Department</th>
//               <th>Break Exceeds</th>
//               <th>Late Marks</th>
//               <th>Action</th>
//             </tr>
//           </thead>
//           <tbody>
//             {filteredViolators.length === 0 ? (
//               <tr>
//                 <td colSpan="6" style={{ textAlign: "center", color: "#94a3b8", padding: "28px" }}>
//                   🎉 No employees found matching this filter!
//                 </td>
//               </tr>
//             ) : (
//               filteredViolators.map((emp, i) => (
//                 <tr key={i} onClick={() => setDetailModalEmp(emp)} className="clickable-row">
//                   <td><strong>{emp.emp_code}</strong></td>
//                   <td>
//                     <div className="emp-name-cell">
//                       <div className="emp-avatar">{emp.name.charAt(0)}</div>
//                       <span>{emp.name}</span>
//                     </div>
//                   </td>
//                   <td>
//                     <span className="dept-tag">{emp.department}</span>
//                   </td>
//                   <td>
//                     {emp.break_violations > 0 ? (
//                       <span className="txt-absent">
//                         <strong>{emp.break_violations} Days</strong>
//                       </span>
//                     ) : (
//                       "—"
//                     )}
//                   </td>
//                   <td>
//                     {emp.late > 0 ? (
//                       <span className="txt-late">
//                         <strong>{emp.late} Marks</strong>
//                       </span>
//                     ) : (
//                       "—"
//                     )}
//                   </td>
//                   <td>
//                     <button 
//                       className="view-details-btn" 
//                       onClick={(e) => { 
//                         e.stopPropagation(); 
//                         setDetailModalEmp(emp); 
//                       }}
//                     >
//                       View Details <ChevronRight size={14} />
//                     </button>
//                   </td>
//                 </tr>
//               ))
//             )}
//           </tbody>
//         </table>
//       </div>

//       {/* 🔷 POP-UP MODAL 1: TARGET HR EMAIL DISPATCH MODAL */}
//       {isHrEmailModalOpen && createPortal(
//         <div className="modal-backdrop-portal" onClick={() => setIsHrEmailModalOpen(false)}>
//           <div className="modal-content-box-portal hr-modal-wide" onClick={(e) => e.stopPropagation()}>
//             <div className="modal-header modal-header-white">
//               <div className="modal-user-info">
//                 <div className="modal-avatar" style={{ background: "#4f46e5" }}><Mail size={22} /></div>
//                 <div>
//                   <h3>Send Rule Infractions Report to HR</h3>
//                   <span className="emp-code-sub">Recipient: <strong>{targetEmail}</strong> | Report Month: {data.report_month || "July-2026"}</span>
//                 </div>
//               </div>
//               <button className="modal-close-btn" onClick={() => setIsHrEmailModalOpen(false)}>
//                 <X size={20} />
//               </button>
//             </div>

//             {/* SUCCESS TOAST INSIDE MODAL */}
//             {emailStatus === "success" && (
//               <div className="modal-email-toast">
//                 <CheckCircle2 size={18} />
//                 <span>Rule Infractions Report successfully sent to <strong>{targetEmail}</strong> via PHPMailer SMTP! 📧</span>
//                 <button onClick={() => setEmailStatus(null)} className="toast-close-btn"><X size={14} /></button>
//               </div>
//             )}

//             <div className="modal-body-scrollable">
//               <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "16px" }}>
//                 <div>
//                   <h4 style={{ margin: 0, color: "#1e293b" }}>
//                     Rule Broken Employees ({deptFilteredViolators.length} People {selectedDept !== "ALL" ? `- ${selectedDept}` : ""})
//                   </h4>
//                   <p style={{ margin: "4px 0 0 0", fontSize: "12px", color: "#64748b" }}>
//                     Review the details below that will be sent via PHPMailer to <strong>{targetEmail}</strong>.
//                   </p>
//                 </div>

//                 <button 
//                   className="send-email-hr-btn" 
//                   onClick={handleSendEmailToHR}
//                   disabled={emailSending}
//                   style={{ padding: "10px 20px" }}
//                 >
//                   <Send size={16} />
//                   {emailSending ? "Sending Email via SMTP..." : `Send Email to ${targetEmail}`}
//                 </button>
//               </div>

//               {/* TABLE OF RULE BROKEN EMPLOYEES TO BE SENT */}
//               <table className="modal-details-table">
//                 <thead>
//                   <tr>
//                     <th>Emp Code</th>
//                     <th>Employee Name</th>
//                     <th>Department</th>
//                     <th>Break Exceeds</th>
//                     <th>Max Break</th>
//                     <th>Late Marks</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {deptFilteredViolators.map((emp, idx) => (
//                     <tr key={idx}>
//                       <td><strong>{emp.emp_code}</strong></td>
//                       <td><strong>{emp.name}</strong></td>
//                       <td><span className="dept-tag">{emp.department}</span></td>
//                       <td className="txt-absent">{emp.break_violations > 0 ? `${emp.break_violations} Days` : "—"}</td>
//                       <td>{emp.max_break_time || "—"}</td>
//                       <td className="txt-late">{emp.late > 0 ? `${emp.late} Marks (${emp.raw_late} Total)` : "—"}</td>
//                     </tr>
//                   ))}
//                 </tbody>
//               </table>
//             </div>
//           </div>
//         </div>,
//         document.body
//       )}

//       {/* 🔷 POP-UP MODAL 2: INDIVIDUAL EMPLOYEE BREAK & LATE DETAIL MODAL */}
//       {detailModalEmp && createPortal(
//         <div className="modal-backdrop-portal" onClick={() => setDetailModalEmp(null)}>
//           <div className="modal-content-box-portal" onClick={(e) => e.stopPropagation()}>
//             <div className="modal-header modal-header-white">
//               <div className="modal-user-info">
//                 <div className="modal-avatar">{detailModalEmp.name.charAt(0)}</div>
//                 <div>
//                   <h3>{detailModalEmp.name} <span className="emp-code-sub">({detailModalEmp.emp_code})</span></h3>
//                   <span className="dept-tag">{detailModalEmp.department}</span>
//                 </div>
//               </div>
//               <button className="modal-close-btn" onClick={() => setDetailModalEmp(null)}>
//                 <X size={20} />
//               </button>
//             </div>

//             <div className="modal-body-scrollable">
//               {/* BREAK EXCEEDED DETAILS SECTION */}
//               <div className="modal-section">
//                 <div className="modal-section-title text-red">
//                   <Coffee size={18} />
//                   <h4>Break Exceeded Details — {detailModalEmp.break_violations} Days</h4>
//                 </div>

//                 {detailModalEmp.break_violation_days?.length === 0 ? (
//                   <div className="empty-violation-box green-box">
//                     <Award size={18} />
//                     <span>No break rule violations recorded for this month! Break was always within 1h 02m.</span>
//                   </div>
//                 ) : (
//                   <table className="modal-details-table">
//                     <thead>
//                       <tr>
//                         <th>Date</th>
//                         <th>Break Time Recorded</th>
//                         <th>Allowed Limit</th>
//                         <th style={{ textAlign: "right" }}>Excess Time Over Limit</th>
//                       </tr>
//                     </thead>
//                     <tbody>
//                       {detailModalEmp.break_violation_days.map((item, idx) => (
//                         <tr key={idx}>
//                           <td><strong>Day {item.day}</strong> ({item.date})</td>
//                           <td><span className="break-duration-badge">{item.break_time}</span></td>
//                           <td>01:02 (1h 02m)</td>
//                           <td style={{ textAlign: "right" }}>
//                             <span className="excess-time-badge">
//                               +{item.excess_mins} mins over limit
//                             </span>
//                           </td>
//                         </tr>
//                       ))}
//                     </tbody>
//                   </table>
//                 )}
//               </div>

//               {/* LATE MARKS DETAILS SECTION */}
//               <div className="modal-section">
//                 <div className="modal-section-title text-amber">
//                   <Clock size={18} />
//                   <h4>Late Mark Details — {detailModalEmp.raw_late} Total Instances (2 Grace Allowed)</h4>
//                 </div>

//                 {detailModalEmp.late_days?.length === 0 ? (
//                   <div className="empty-violation-box green-box">
//                     <UserCheck size={18} />
//                     <span>No late arrivals recorded for this month. Always arrived on time!</span>
//                   </div>
//                 ) : (
//                   <table className="modal-details-table">
//                     <thead>
//                       <tr>
//                         <th>Date</th>
//                         <th>In Time Recorded</th>
//                         <th>Shift Threshold</th>
//                         <th style={{ textAlign: "right" }}>Late Status</th>
//                       </tr>
//                     </thead>
//                     <tbody>
//                       {detailModalEmp.late_days.map((item, idx) => (
//                         <tr key={idx}>
//                           <td><strong>Day {item.day}</strong> ({item.date})</td>
//                           <td><strong style={{ color: "#d97706" }}>{item.in_time}</strong></td>
//                           <td>15:40</td>
//                           <td style={{ textAlign: "right" }}>
//                             {item.is_grace ? (
//                               <span className="status-pill status-normal">
//                                 Grace #{item.instance_num}/2 (Allowed)
//                               </span>
//                             ) : (
//                               <span className="status-pill status-absent">
//                                 Penalty Late Mark #{item.instance_num - 2}
//                               </span>
//                             )}
//                           </td>
//                         </tr>
//                       ))}
//                     </tbody>
//                   </table>
//                 )}
//               </div>
//             </div>
//           </div>
//         </div>,
//         document.body
//       )}

//       {/* 🔷 POP-UP MODAL 3: CUSTOM ON-SCREEN SUCCESS POPUP MODAL */}
//       {showSuccessPopup && createPortal(
//         <div className="modal-backdrop-portal" style={{ zIndex: 2147483647 }} onClick={() => setShowSuccessPopup(false)}>
//           <div className="success-pop-card" onClick={(e) => e.stopPropagation()}>
//             <div className="success-pop-icon">
//               <CheckCircle2 size={44} color="#22c55e" />
//             </div>
//             <h3>Email Sent Successfully! 📧</h3>
//             <p>
//               The Attendance Rule Infractions Report has been sent to<br />
//               <strong style={{ color: "#4f46e5", fontSize: "15px" }}>{targetEmail}</strong>
//             </p>
//             <div className="success-pop-details">
//               <span>Report Month: <strong>{data.report_month || "July-2026"}</strong></span>
//               <span>Total Violators: <strong>{deptFilteredViolators.length} Employees</strong></span>
//             </div>
//             <button className="success-pop-btn" onClick={() => setShowSuccessPopup(false)}>
//               Done
//             </button>
//           </div>
//         </div>,
//         document.body
//       )}
//     </div>
//   );
// }

// export default AttendanceRuleInfractions;




















import React, { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { 
  Building2, 
  Users, 
  UserCheck,
  Clock, 
  Search, 
  Award, 
  CalendarDays, 
  Coffee,
  X,
  ChevronRight,
  Mail,
  AlertOctagon,
  CheckCircle2,
  Filter,
  Send
} from "lucide-react";
import AttendanceLoader from "./AttendanceLoader";
import "../styles/AttendanceRuleInfractions.css";

function AttendanceRuleInfractions() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [selectedDept, setSelectedDept] = useState("ALL");
  const [activeFilter, setActiveFilter] = useState("ALL"); // ALL, BREAK, LATE
  const [search, setSearch] = useState("");
  const [detailModalEmp, setDetailModalEmp] = useState(null);
  const [isHrEmailModalOpen, setIsHrEmailModalOpen] = useState(false);
  const [emailSending, setEmailSending] = useState(false);
  const [emailStatus, setEmailStatus] = useState(null);
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);

  const targetEmail = "nisha.kenchgali@genesistech.co.in";

  const parseJsonSafe = (text) => {
    const jsonStart = text.search(/[\{\[]/);
    if (jsonStart !== -1) {
      return JSON.parse(text.substring(jsonStart));
    }
    return JSON.parse(text);
  };

  useEffect(() => {
    fetch("/gt-api/get_department_analytics.php")
      .then((res) => res.text())
      .then((text) => {
        const result = parseJsonSafe(text);
        setData(result);
        setLoading(false);
      })
      .catch((err) => {
        console.error("Rule Infractions Fetch Error:", err);
        setLoading(false);
      });
  }, []);

  // Lock background scroll when any modal is open
  useEffect(() => {
    if (detailModalEmp || isHrEmailModalOpen || showSuccessPopup) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
    return () => {
      document.body.style.overflow = "";
    };
  }, [detailModalEmp, isHrEmailModalOpen, showSuccessPopup]);

  const handleSendEmailToHR = async () => {
    setEmailSending(true);
    setEmailStatus(null);
    try {
      const res = await fetch("/gt-api/send_rule_violations_email.php");
      const text = await res.text();
      const result = parseJsonSafe(text);

      if (result.status === "success") {
        setEmailStatus("success");
        setShowSuccessPopup(true);
      } else {
        alert("❌ Email Sending Error: " + (result.message || "Failed to send email"));
        setEmailStatus("error");
      }
      setEmailSending(false);
    } catch (err) {
      console.error("Email Sending Error:", err);
      alert("❌ Failed to connect to email server");
      setEmailStatus("error");
      setEmailSending(false);
    }
  };

  if (loading) {
    return (
      <AttendanceLoader 
        message="Calculating Rule Infractions & Analytics..." 
        subtitle="Please wait a moment while break durations and late arrival metrics are processed." 
      />
    );
  }

  if (!data || !data.department_summaries) {
    return <div className="infraction-empty">No rule infraction data available.</div>;
  }

  const allDepts = data.all_departments || [];
  const deptSummaries = data.department_summaries || [];
  const allEmployees = data.employee_records || [];

  // Filter ONLY rule violators (employees with break violations OR penalty late marks)
  const ruleViolatorsList = allEmployees.filter((emp) => emp.has_break_violation || emp.has_late);

  // Department-filtered rule violators
  const deptFilteredViolators = ruleViolatorsList.filter((emp) => 
    selectedDept === "ALL" || emp.department === selectedDept
  );

  // Dynamic Summary Metrics per department
  let activeSummary = {
    total_violators: deptFilteredViolators.length,
    break_violators: deptFilteredViolators.filter((e) => e.has_break_violation).length,
    late_violators: deptFilteredViolators.filter((e) => e.has_late).length,
    total_break_days: 0,
    total_late_marks: 0
  };

  deptFilteredViolators.forEach((e) => {
    activeSummary.total_break_days += e.break_violations;
    activeSummary.total_late_marks += e.late;
  });

  const handleCardFilterClick = (filterType) => {
    if (activeFilter === filterType) {
      setActiveFilter("ALL");
    } else {
      setActiveFilter(filterType);
    }
  };

  // Filtered table rows
  const filteredViolators = deptFilteredViolators.filter((emp) => {
    const matchesSearch = 
      emp.name.toLowerCase().includes(search.toLowerCase()) ||
      emp.emp_code.toLowerCase().includes(search.toLowerCase()) ||
      emp.department.toLowerCase().includes(search.toLowerCase());

    let matchesFilter = true;
    if (activeFilter === "BREAK") matchesFilter = emp.has_break_violation;
    if (activeFilter === "LATE") matchesFilter = emp.has_late;

    return matchesSearch && matchesFilter;
  });

  return (
    <div className="infraction-container">
      {/* 🔷 SCREEN HEADER */}
      <div className="infraction-header">
        <div>
          <h2>⚠️ Rule Broken Employees Report</h2>
          <p className="infraction-subtitle">
            <CalendarDays size={14} style={{ display: "inline", marginRight: "4px" }} />
            Report Month: <strong>{data.report_month || "Current Month"}</strong>
          </p>
        </div>

        <div className="dept-filter-controls">
          <Building2 size={18} className="dept-icon" />
          <select 
            className="dept-select"
            value={selectedDept}
            onChange={(e) => {
              setSelectedDept(e.target.value);
              setActiveFilter("ALL");
            }}
          >
            <option value="ALL">All Departments ({deptSummaries.length} Teams)</option>
            {allDepts.map((dept, i) => (
              <option key={i} value={dept}>
                {dept}
              </option>
            ))}
          </select>
        </div>
      </div>

      {/* 🔷 SUCCESS NOTIFICATION TOAST ON MAIN SCREEN */}
      {emailStatus === "success" && (
        <div className="email-toast success-toast">
          <CheckCircle2 size={18} />
          <span>Rule Infractions Report successfully sent to <strong>{targetEmail}</strong> via PHPMailer SMTP! 📧</span>
          <button onClick={() => setEmailStatus(null)} className="toast-close"><X size={14} /></button>
        </div>
      )}

      {/* 🔷 4 SYMMETRICAL PREMIUM SUMMARY CARDS */}
      <div className="infraction-metrics-grid">
        <div 
          className={`infraction-card card-purple ${activeFilter === 'ALL' ? 'active-card' : ''}`}
          onClick={() => setActiveFilter('ALL')}
          style={{ cursor: "pointer" }}
          title={`Click to view all ${activeSummary.total_violators} rule broken employees in ${selectedDept === 'ALL' ? 'all departments' : selectedDept}`}
        >
          <div className="card-icon-wrapper icon-purple">
            <AlertOctagon size={22} color="#8b5cf6" />
          </div>
          <div className="card-info">
            <p>Rule Broken Employees</p>
            <strong>{activeSummary.total_violators} <span className="sub-label">People Total</span></strong>
          </div>
        </div>

        <div 
          className={`infraction-card card-red ${activeFilter === 'BREAK' ? 'active-card' : ''}`}
          onClick={() => handleCardFilterClick('BREAK')}
          style={{ cursor: "pointer" }}
          title={`Click to filter break exceeded employees in ${selectedDept === 'ALL' ? 'all departments' : selectedDept}`}
        >
          <div className="card-icon-wrapper icon-red">
            <Coffee size={22} color="#ef4444" />
          </div>
          <div className="card-info">
            <p>Break Exceeded</p>
            <strong>{activeSummary.break_violators} <span className="sub-label">People</span></strong>
          </div>
        </div>

        <div 
          className={`infraction-card card-amber ${activeFilter === 'LATE' ? 'active-card' : ''}`}
          onClick={() => handleCardFilterClick('LATE')}
          style={{ cursor: "pointer" }}
          title={`Click to filter late mark employees in ${selectedDept === 'ALL' ? 'all departments' : selectedDept}`}
        >
          <div className="card-icon-wrapper icon-amber">
            <Clock size={22} color="#f59e0b" />
          </div>
          <div className="card-info">
            <p>Late Marks</p>
            <strong>{activeSummary.late_violators} <span className="sub-label">People</span></strong>
          </div>
        </div>

        {/* 🔷 CLICKABLE TARGET HR RECIPIENT CARD */}
        <div 
          className="infraction-card card-blue clickable-hr-card" 
          onClick={() => setIsHrEmailModalOpen(true)}
          title={`Click to open email modal and send report to ${targetEmail}`}
        >
          <div className="card-icon-wrapper icon-indigo">
            <Mail size={22} color="#4f46e5" />
          </div>
          <div className="card-info">
            <p>Target HR Recipient</p>
            <strong className="hr-email-text" title={targetEmail}>{targetEmail}</strong>
            <span className="send-hr-badge">Click to Send Email 📧</span>
          </div>
        </div>
      </div>

      {/* 🔷 RULE BROKEN EMPLOYEES TABLE */}
      <div className="infraction-table-section">
        <div className="infraction-table-header">
          <div>
            <h3 style={{ margin: 0 }}>
              Rule Infraction Employees List 
              <span className="count-badge">({filteredViolators.length} Employees)</span>
              {selectedDept !== "ALL" && (
                <span style={{ fontSize: "13px", color: "#4338ca", marginLeft: "8px", fontWeight: "normal" }}>
                  [{selectedDept} Team]
                </span>
              )}
            </h3>
            {activeFilter !== "ALL" && (
              <p style={{ margin: "4px 0 0 0", fontSize: "12px", color: "#4f46e5", fontWeight: "600" }}>
                <Filter size={12} style={{ display: "inline", marginRight: "4px" }} />
                Filtered by: {
                  activeFilter === 'BREAK' ? 'Break Exceeded People' : 'Late Marks People'
                }
              </p>
            )}
          </div>

          <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
            {(activeFilter !== "ALL" || selectedDept !== "ALL") && (
              <button className="reset-filter-btn" onClick={() => { setActiveFilter("ALL"); setSelectedDept("ALL"); }}>
                Reset All Filters
              </button>
            )}
            <div className="infraction-search-box">
              <Search size={16} className="search-icon" />
              <input
                type="text"
                placeholder="Search employee or department..."
                value={search}
                onChange={(e) => setSearch(e.target.value)}
              />
            </div>
          </div>
        </div>

        <table className="infraction-table">
          <thead>
            <tr>
              <th>Emp Code</th>
              <th>Employee Name</th>
              <th>Department</th>
              <th>Break Exceeds</th>
              <th>Late Marks</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {filteredViolators.length === 0 ? (
              <tr>
                <td colSpan="6" style={{ textAlign: "center", color: "#94a3b8", padding: "28px" }}>
                  🎉 No employees found matching this filter!
                </td>
              </tr>
            ) : (
              filteredViolators.map((emp, i) => (
                <tr key={i} onClick={() => setDetailModalEmp(emp)} className="clickable-row">
                  <td><strong>{emp.emp_code}</strong></td>
                  <td>
                    <div className="emp-name-cell">
                      <div className="emp-avatar">{emp.name.charAt(0)}</div>
                      <span>{emp.name}</span>
                    </div>
                  </td>
                  <td>
                    <span className="dept-tag">{emp.department}</span>
                  </td>
                  <td>
                    {emp.break_violations > 0 ? (
                      <span className="txt-absent">
                        <strong>{emp.break_violations}</strong>
                      </span>
                    ) : (
                      "—"
                    )}
                  </td>
                  <td>
                    {emp.late > 0 ? (
                      <span className="txt-late">
                        <strong>{emp.late}</strong>
                      </span>
                    ) : (
                      "—"
                    )}
                  </td>
                  <td>
                    <button 
                      className="view-details-btn" 
                      onClick={(e) => { 
                        e.stopPropagation(); 
                        setDetailModalEmp(emp); 
                      }}
                    >
                      View Details <ChevronRight size={14} />
                    </button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      {/* 🔷 POP-UP MODAL 1: TARGET HR EMAIL DISPATCH MODAL */}
      {isHrEmailModalOpen && createPortal(
        <div className="modal-backdrop-portal" onClick={() => setIsHrEmailModalOpen(false)}>
          <div className="modal-content-box-portal hr-modal-wide" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header modal-header-white">
              <div className="modal-user-info">
                <div className="modal-avatar" style={{ background: "#4f46e5" }}><Mail size={22} /></div>
                <div>
                  <h3>Send Rule Infractions Report to HR</h3>
                  <span className="emp-code-sub">Recipient: <strong>{targetEmail}</strong> | Report Month: {data.report_month || "July-2026"}</span>
                </div>
              </div>
              <button className="modal-close-btn" onClick={() => setIsHrEmailModalOpen(false)}>
                <X size={20} />
              </button>
            </div>

            {/* SUCCESS TOAST INSIDE MODAL */}
            {emailStatus === "success" && (
              <div className="modal-email-toast">
                <CheckCircle2 size={18} />
                <span>Rule Infractions Report successfully sent to <strong>{targetEmail}</strong> via PHPMailer SMTP! 📧</span>
                <button onClick={() => setEmailStatus(null)} className="toast-close-btn"><X size={14} /></button>
              </div>
            )}

            <div className="modal-body-scrollable">
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "16px" }}>
                <div>
                  <h4 style={{ margin: 0, color: "#1e293b" }}>
                    Rule Broken Employees ({deptFilteredViolators.length} People {selectedDept !== "ALL" ? `- ${selectedDept}` : ""})
                  </h4>
                  <p style={{ margin: "4px 0 0 0", fontSize: "12px", color: "#64748b" }}>
                    Review the details below that will be sent via PHPMailer to <strong>{targetEmail}</strong>.
                  </p>
                </div>

                <button 
                  className="send-email-hr-btn" 
                  onClick={handleSendEmailToHR}
                  disabled={emailSending}
                  style={{ padding: "10px 20px" }}
                >
                  <Send size={16} />
                  {emailSending ? "Sending Email via SMTP..." : `Send Email to ${targetEmail}`}
                </button>
              </div>

              {/* TABLE OF RULE BROKEN EMPLOYEES TO BE SENT */}
              <table className="modal-details-table">
                <thead>
                  <tr>
                    <th>Emp Code</th>
                    <th>Employee Name</th>
                    <th>Department</th>
                    <th>Break Exceeds</th>
                    <th>Max Break</th>
                    <th>Late Marks</th>
                  </tr>
                </thead>
                <tbody>
                  {deptFilteredViolators.map((emp, idx) => (
                    <tr key={idx}>
                      <td><strong>{emp.emp_code}</strong></td>
                      <td><strong>{emp.name}</strong></td>
                      <td><span className="dept-tag">{emp.department}</span></td>
                      <td className="txt-absent">{emp.break_violations > 0 ? emp.break_violations : "—"}</td>
                      <td>{emp.max_break_time || "—"}</td>
                      <td className="txt-late">{emp.late > 0 ? emp.late : "—"}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>,
        document.body
      )}

      {/* 🔷 POP-UP MODAL 2: INDIVIDUAL EMPLOYEE BREAK & LATE DETAIL MODAL */}
      {detailModalEmp && createPortal(
        <div className="modal-backdrop-portal" onClick={() => setDetailModalEmp(null)}>
          <div className="modal-content-box-portal" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header modal-header-white">
              <div className="modal-user-info">
                <div className="modal-avatar">{detailModalEmp.name.charAt(0)}</div>
                <div>
                  <h3>{detailModalEmp.name} <span className="emp-code-sub">({detailModalEmp.emp_code})</span></h3>
                  <span className="dept-tag">{detailModalEmp.department}</span>
                </div>
              </div>
              <button className="modal-close-btn" onClick={() => setDetailModalEmp(null)}>
                <X size={20} />
              </button>
            </div>

            <div className="modal-body-scrollable">
              {/* BREAK EXCEEDED DETAILS SECTION */}
              <div className="modal-section">
                <div className="modal-section-title text-red">
                  <Coffee size={18} />
                  <h4>Break Exceeded Details — {detailModalEmp.break_violations} Days</h4>
                </div>

                {detailModalEmp.break_violation_days?.length === 0 ? (
                  <div className="empty-violation-box green-box">
                    <Award size={18} />
                    <span>No break rule violations recorded for this month! Break was always within 1h 02m.</span>
                  </div>
                ) : (
                  <table className="modal-details-table">
                    <thead>
                      <tr>
                        <th>Date</th>
                        <th>Break Time Recorded</th>
                        <th>Allowed Limit</th>
                        <th style={{ textAlign: "right" }}>Excess Time Over Limit</th>
                      </tr>
                    </thead>
                    <tbody>
                      {detailModalEmp.break_violation_days.map((item, idx) => (
                        <tr key={idx}>
                          <td><strong>Day {item.day}</strong> ({item.date})</td>
                          <td><span className="break-duration-badge">{item.break_time}</span></td>
                          <td>01:02 (1h 02m)</td>
                          <td style={{ textAlign: "right" }}>
                            <span className="excess-time-badge">
                              +{item.excess_mins} mins over limit
                            </span>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                )}
              </div>

              {/* LATE MARKS DETAILS SECTION */}
              <div className="modal-section">
                <div className="modal-section-title text-amber">
                  <Clock size={18} />
                  <h4>Late Mark Details — {detailModalEmp.raw_late} Total Instances (2 Grace Allowed)</h4>
                </div>

                {detailModalEmp.late_days?.length === 0 ? (
                  <div className="empty-violation-box green-box">
                    <UserCheck size={18} />
                    <span>No late arrivals recorded for this month. Always arrived on time!</span>
                  </div>
                ) : (
                  <table className="modal-details-table">
                    <thead>
                      <tr>
                        <th>Date</th>
                        <th>In Time Recorded</th>
                        <th>Shift Threshold</th>
                        <th style={{ textAlign: "right" }}>Late Status</th>
                      </tr>
                    </thead>
                    <tbody>
                      {detailModalEmp.late_days.map((item, idx) => (
                        <tr key={idx}>
                          <td><strong>Day {item.day}</strong> ({item.date})</td>
                          <td><strong style={{ color: "#d97706" }}>{item.in_time}</strong></td>
                          <td>15:40</td>
                          <td style={{ textAlign: "right" }}>
                            {item.is_grace ? (
                              <span className="status-pill status-normal">
                                Grace #{item.instance_num}/2 (Allowed)
                              </span>
                            ) : (
                              <span className="status-pill status-absent">
                                Penalty Late Mark #{item.instance_num - 2}
                              </span>
                            )}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                )}
              </div>
            </div>
          </div>
        </div>,
        document.body
      )}

      {/* 🔷 POP-UP MODAL 3: CUSTOM ON-SCREEN SUCCESS POPUP MODAL */}
      {showSuccessPopup && createPortal(
        <div className="modal-backdrop-portal" style={{ zIndex: 2147483647 }} onClick={() => setShowSuccessPopup(false)}>
          <div className="success-pop-card" onClick={(e) => e.stopPropagation()}>
            <div className="success-pop-icon">
              <CheckCircle2 size={44} color="#22c55e" />
            </div>
            <h3>Email Sent Successfully! 📧</h3>
            <p>
              The Attendance Rule Infractions Report has been sent to<br />
              <strong style={{ color: "#4f46e5", fontSize: "15px" }}>{targetEmail}</strong>
            </p>
            <div className="success-pop-details">
              <span>Report Month: <strong>{data.report_month || "July-2026"}</strong></span>
              <span>Total Violators: <strong>{deptFilteredViolators.length} Employees</strong></span>
            </div>
            <button className="success-pop-btn" onClick={() => setShowSuccessPopup(false)}>
              Done
            </button>
          </div>
        </div>,
        document.body
      )}
    </div>
  );
}

export default AttendanceRuleInfractions;
